import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useClickedOutside } from '../../../../hooks/useClickedOutside';

import * as Styled from '../_components';

const Info = ({ width, title, children, onClose }) => {
  const container = useRef();

  useClickedOutside(container, () => onClose());

  return (
    <Styled.ModalBackdrop>
      <Styled.ModalContainer ref={container}>
        <Styled.ModalContentWrapper width={width}>
          <Styled.ModalHeader>
            {/* <Img src={ALARM_ICON} size={[40, 40]} style={{ fill: COLORS_CONFIG.PRIMARY.POPPY_RED }} /> */}
            <h2>{title}</h2>
          </Styled.ModalHeader>
          {children}
        </Styled.ModalContentWrapper>
      </Styled.ModalContainer>
    </Styled.ModalBackdrop>
  );
};

Info.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  width: PropTypes.string,
};

Info.defaultProps = {
  width: '560px',
};

export default Info;
